import { LayoutOptions } from "./helpers/prop-types-helper";
import * as LayoutOptionTypes from "./layout-options";

import * as Shared from "./shared";

export * from "./blocks";
export * from "./typings";
export * from "./helpers";

const updatedLayoutOptions = Object.assign(LayoutOptions, LayoutOptionTypes);
export { updatedLayoutOptions as LayoutOptions };
export { processLayoutOptions } from "./helpers/prop-types-helper";

export { Shared };
